/**
 * A skip-to-content link (WCAG 2.4.1 Bypass Blocks). Visually hidden until focused, then it jumps
 * keyboard users straight to `#main-content`. Must be the FIRST focusable element on the page.
 */
export function SkipLink({ targetId = 'main-content' }: { targetId?: string }) {
  return (
    <a className="skip-link" href={`#${targetId}`}>
      Skip to main content
    </a>
  );
}
